import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const BottomNav = () => {
  const location = useLocation();

  useEffect(() => {
    // Add class to body when component mounts
    document.body.classList.add('has-bottom-nav');

    // Remove class when component unmounts
    return () => {
      document.body.classList.remove('has-bottom-nav');
    };
  }, []);

  // Function to check if the current path matches
  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bottom-nav">
      <div className="bottom-nav-content">
        {/* Home */}
        <Link 
          to="/" 
          className={`bottom-nav-item ${isActive('/') ? 'active' : ''}`}
        >
          <svg 
            className="bottom-nav-icon" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          <span className="bottom-nav-label">Home</span>
        </Link>

        {/* Games */}
        <Link 
          to="/games" 
          className={`bottom-nav-item ${isActive('/games') ? 'active' : ''}`}
        >
          <svg 
            className="bottom-nav-icon" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <rect x="2" y="7" width="20" height="15" rx="2" ry="2" />
            <polyline points="17 2 12 7 7 2" />
          </svg>
          <span className="bottom-nav-label">Games</span>
        </Link>

        {/* Apps */}
        <Link 
          to="/apps" 
          className={`bottom-nav-item ${isActive('/apps') ? 'active' : ''}`}
        >
          <svg 
            className="bottom-nav-icon" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
            <rect x="3" y="14" width="7" height="7" />
          </svg>
          <span className="bottom-nav-label">Apps</span>
        </Link>

        {/* Blogs */}
        <Link 
          to="/blogs" 
          className={`bottom-nav-item ${isActive('/blogs') ? 'active' : ''}`}
        >
          <svg 
            className="bottom-nav-icon" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
            <polyline points="10 9 9 9 8 9" />
          </svg>
          <span className="bottom-nav-label">Blogs</span>
        </Link>
      </div>
    </nav>
  );
};

export default BottomNav;